import { useEffect, useState, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import ModalComponent from '../../components/formComponent/ModalComponent';
import moment from 'moment';
import { message, Radio, Space, Spin, Checkbox, Button, Row, Col } from "antd";
import FormSelect from '../../components/general/FormSelect';
import FormButton from '../../components/general/FormButton';
import { INPUT_SIZE, PRIMARY_COLOR } from '../../common/ThemeConstants';
import FormTextField from '../../components/general/FormTextField';
import FormContainer from '../../components/general/FormContainer';
import { postRequest } from "../../services/mainApp.service";
import { useNavigate } from 'react-router-dom';
import Title from "antd/lib/typography/Title";
import OrderCancelBill from '../../components/NewComponents/OrderCancelBill';
import OrderCancelKOT from '../../components/NewComponents/OrderCancelKOT';

const UpdateTableWaiterRiderModal = (props) => {
    const {
        updateTableWaiterRiderModalObj,
        setUpdateTableWaiterRiderModalObj,
        userData,
        toggleTableRiderWaiterModal,
        tableWaiterRiderModalOpen,
        selectedCurrentOrder,
        handleUpdate
    } = props;

    const [spin, setSpin] = useState(false);
    const [selectedId, setSelectedId] = useState(null);
    const [cancelBillData, setCancelBillData] = useState(null);
    const [cancelBillItems, setCancelBillItems] = useState([]);
    const [shouldPrintCancelBill, setShouldPrintCancelBill] = useState(false);
    const [shouldPrintCancelKOT, setShouldPrintCancelKOT] = useState(false);
    const cancelBillRef = useRef(null);
    const cancelKOTRef = useRef(null);
    const dispatch = useDispatch();

    // Trigger print when component is ready (after data is set)
    useEffect(() => {
        if (shouldPrintCancelBill && cancelBillData && cancelBillItems.length > 0) {
            // Use requestAnimationFrame to stay in user action context
            requestAnimationFrame(() => {
                setTimeout(() => {
                    if (cancelBillRef.current) {
                        try {
                            cancelBillRef.current.print();
                            setShouldPrintCancelBill(false);
                        } catch (error) {
                            console.error("Error printing cancel bill:", error);
                        }
                    }
                }, 500);
            });
        }
    }, [shouldPrintCancelBill, cancelBillData, cancelBillItems]);

    // Trigger KOT print after bill print
    useEffect(() => {
        if (shouldPrintCancelKOT && cancelBillData && cancelBillItems.length > 0) {
            // Wait a bit after bill print completes
            requestAnimationFrame(() => {
                setTimeout(() => {
                    if (cancelKOTRef.current) {
                        try {
                            cancelKOTRef.current.print();
                            setShouldPrintCancelKOT(false);
                        } catch (error) {
                            console.error("Error printing cancel KOT:", error);
                        }
                    }
                }, 1000);
            });
        }
    }, [shouldPrintCancelKOT, cancelBillData, cancelBillItems]);

    const saveFunc = async () => {
        let orderMasterId = updateTableWaiterRiderModalObj?.OrderMasterId[0] ?? 0;

        if (orderMasterId > 0) {

            let operationId, riderId, waiterId, tableId, orderCancelReasonId = null;

            if (updateTableWaiterRiderModalObj.modalFunc == 'TableTransfer') {
                operationId = 2;
                tableId = selectedId;
            }
            else if (updateTableWaiterRiderModalObj.modalFunc == 'ChangeWaiter') {
                operationId = 3;
                waiterId = selectedId;
            }
            else if (updateTableWaiterRiderModalObj.modalFunc == 'ChangeRider') {
                operationId = 4;
                riderId = selectedId;
            }
            else if (updateTableWaiterRiderModalObj.modalFunc == 'TableMerge') {
                operationId = 6;
                tableId = selectedId;
            }
            else if (updateTableWaiterRiderModalObj.modalFunc == 'TableUnMerge') {
                operationId = 7;
            }
            else if (updateTableWaiterRiderModalObj.modalFunc == 'OrderCancelReason') {
                operationId = 8;
                orderCancelReasonId = selectedId;
            }

            postRequest("/UpdateCoverWaiterRider", {
                // ...popupIntialFormValues,
                OperationId: operationId,
                CompanyId: userData.CompanyId,
                UserId: userData.UserId,
                UserIP: "1.2.2.1",
                OrderMasterId: orderMasterId,
                RiderId: riderId,
                WaiterId: waiterId,
                TableId: tableId,
                BranchId: selectedCurrentOrder[0]?.BranchId,
                OrderCancelReasonId: orderCancelReasonId
            })
                .then(async (response) => {
                    if (response?.error === true) {
                        message.error(response?.errorMessage);
                        return;
                    }
                    if (response?.data?.response === false) {
                        message.error(response?.DataSet?.Table?.errorMessage);
                        return;
                    }
                    message.success(response.successMessage);

                    handleUpdate(response?.data?.DataSet?.Table3);



                    dispatch({ type: "REFRESH_STATS", payload: 1 });

                    // If order was cancelled, fetch order details and print cancel bill
                    if (updateTableWaiterRiderModalObj.modalFunc == 'OrderCancelReason') {
                        try {
                            const orderDetailResponse = await postRequest("getOrderDetail", {
                                OperationId: 1,
                                CompanyId: userData.CompanyId,
                                OrderId: orderMasterId,
                                UserId: userData.UserId,
                                UserIP: "192.1.1.1",
                            });

                            if (orderDetailResponse?.data?.DataSet) {
                                const orderDetailData = orderDetailResponse.data.DataSet;
                                const orderMaster = orderDetailData.Table?.[0];
                                const orderItemsData = orderDetailData.Table1 || [];

                                if (orderMaster && orderItemsData.length > 0) {
                                    const cancelData = {
                                        ...orderMaster,
                                        CancelDate: new Date().toISOString(),
                                    };

                                    // Set the data first, then trigger print after components mount
                                    setCancelBillData(cancelData);
                                    setCancelBillItems(orderItemsData);
                                    setShouldPrintCancelBill(true);
                                    // Don't close modal here - wait for both prints to complete
                                }
                            }
                        } catch (cancelError) {
                            console.error("Error fetching order details for cancel bill:", cancelError);
                            // If error, close modal anyway
                            setTimeout(() => {
                                toggleTableRiderWaiterModal();
                            }, 500);
                        }
                    } else {
                        // Close modal immediately for non-cancellation operations
                        setTimeout(() => {
                            toggleTableRiderWaiterModal();
                        }, 500);
                    }
                })
                .catch((error) => { });
        }
        else {
            message.error('No Order is Selected, Please Select an Order');
            return;
        }
    };

    const toggleValues = (Id) => {
        setSelectedId(Id);

    };

    const getId = (item) => {

        if (updateTableWaiterRiderModalObj.modalFunc == 'TableTransfer' || updateTableWaiterRiderModalObj.modalFunc == 'TableMerge') {
            return item.TableId;
        }
        else if (updateTableWaiterRiderModalObj.modalFunc == 'ChangeWaiter') {
            return item.WaiterId;
        }
        else if (updateTableWaiterRiderModalObj.modalFunc == 'ChangeRider') {
            return item.RiderId;
        }
        else if (updateTableWaiterRiderModalObj.modalFunc == 'OrderCancelReason') {
            return item.OrderCancelReasonId;
        }

    };

    const getName = (item) => {

        if (updateTableWaiterRiderModalObj.modalFunc == 'TableTransfer' || updateTableWaiterRiderModalObj.modalFunc == 'TableMerge') {
            return item.TableName;
        }
        else if (updateTableWaiterRiderModalObj.modalFunc == 'ChangeWaiter') {
            return item.WaiterName;
        }
        else if (updateTableWaiterRiderModalObj.modalFunc == 'ChangeRider') {
            return item.RiderName;
        }
        else if (updateTableWaiterRiderModalObj.modalFunc == 'OrderCancelReason') {
            return item.OrderCancelReasonName;
        }
    };

    return (
        <div>
            {/* MODAL */}
            <ModalComponent
                isModalVisible={tableWaiterRiderModalOpen}
                // title={updateTableWaiterRiderModalObj.modalTitle}
                // handleCancel={() => saveFunc()}
                // handleOk={() => saveFunc()}
                // destroyOnClose={true}
                okText={'Save'}
                width={"50vw"}
                footer={null}>

                <Space direction="horizontal">
                    <Row>
                        <Col span={24}>
                            <Title level={3} style={{ color: PRIMARY_COLOR }}>
                                {updateTableWaiterRiderModalObj.modalTitle}
                            </Title>
                        </Col>

                    </Row>
                </Space>

                <div>
                    <Spin spinning={spin} />
                    <div style={{ display: "flex", flexWrap: "wrap", width: "100%" }}>
                        <Space direction="horizontal">
                            {(updateTableWaiterRiderModalObj?.modalFunc != 'TableMerge') ?
                                <>
                                    <Radio.Group
                                        optionType="button"
                                        buttonStyle="solid"
                                        // value={updateTableWaiterRiderModalObj.modalSelectedId}
                                        style={{ display: "flex", flexWrap: "wrap" }}
                                    >
                                        {updateTableWaiterRiderModalObj?.modalData?.map((item, index) => (
                                            <div
                                                style={{
                                                    display: "block",
                                                    padding: 10,
                                                    margin: 5,
                                                    background:
                                                        // PRIMARY_COLOR,
                                                        updateTableWaiterRiderModalObj?.modalSelectedId === getId(item) ? PRIMARY_COLOR : "none",
                                                    border: `0.5px solid ${PRIMARY_COLOR}`,
                                                    borderRadius: 3,
                                                    boxShadow: "0 0 1px",
                                                }}
                                            >
                                                <Radio.Button

                                                    key={index}
                                                    onChange={() => {

                                                        let id = getId(item);
                                                        toggleValues(id);
                                                    }}
                                                    value={getId(item)}
                                                // style={{
                                                //     color:
                                                //         updateTableWaiterRiderModalObj?.modalSelectedId === getId(item)
                                                //             ? "white"
                                                //             : PRIMARY_COLOR,
                                                // }}
                                                >
                                                    {getName(item)}
                                                </Radio.Button>
                                            </div>
                                        ))}
                                    </Radio.Group>
                                </> :
                                <>
                                    {updateTableWaiterRiderModalObj?.modalData?.map((item, index) => (
                                        <div
                                            style={{
                                                display: "block",
                                                padding: 10,
                                                margin: 5,
                                                background:
                                                    // PRIMARY_COLOR,
                                                    updateTableWaiterRiderModalObj?.modalSelectedId === getId(item) ? PRIMARY_COLOR : "none",
                                                border: `0.5px solid ${PRIMARY_COLOR}`,
                                                borderRadius: 3,
                                                boxShadow: "0 0 1px",
                                            }}
                                        >
                                            <Checkbox

                                                key={index}
                                                onChange={() => {

                                                    let id = getId(item);
                                                    toggleValues(id);
                                                }}
                                                value={getId(item)}
                                                style={{
                                                    color:
                                                        updateTableWaiterRiderModalObj?.modalSelectedId === getId(item)
                                                            ? "white"
                                                            : PRIMARY_COLOR,
                                                    // "white",

                                                }}
                                            >
                                                {getName(item)}
                                            </Checkbox>
                                        </div>
                                    ))}
                                </>
                            }



                        </Space>
                    </div>

                    <div
                        style={{
                            width: '100%',
                            display: 'flex',
                            justifyContent: 'flex-end',
                            borderTop: '1px solid #eee',
                            paddingTop: '15px',
                            marginTop: '24px',
                        }}
                        align='right'>


                        <Button type='default' onClick={() => {
                            toggleTableRiderWaiterModal();
                        }
                        }>
                            Close
                        </Button>

                        <FormButton
                            // htmlType='submit'
                            type='primary'
                            title='Save'
                            onClick={() => {
                                saveFunc();
                            }}
                        />

                    </div>
                </div >
            </ModalComponent >

            {/* Order Cancel Bill - Auto prints when order is cancelled */}
            {cancelBillData && cancelBillItems.length > 0 && (
                <OrderCancelBill
                    ref={cancelBillRef}
                    orderDetails={cancelBillData}
                    orderItems={cancelBillItems}
                    onAfterPrint={() => {
                        // After bill print, trigger KOT print
                        setShouldPrintCancelKOT(true);
                    }}
                />
            )}

            {/* Order Cancel KOT - Auto prints after cancel bill */}
            {cancelBillData && cancelBillItems.length > 0 && (
                <OrderCancelKOT
                    ref={cancelKOTRef}
                    orderDetails={cancelBillData}
                    orderItems={cancelBillItems}
                    onAfterPrint={() => {
                        // Clear all data after both prints are done
                        setCancelBillData(null);
                        setCancelBillItems([]);
                        setShouldPrintCancelBill(false);
                        setShouldPrintCancelKOT(false);
                        // Close modal after both prints are complete
                        setTimeout(() => {
                            toggleTableRiderWaiterModal();
                        }, 300);
                    }}
                />
            )}
        </div >
    );
};

export default UpdateTableWaiterRiderModal;